import { createSlice } from '@reduxjs/toolkit';

export const Privatedb = createSlice({
    name: 'privatedb',
    initialState: {
        create: {
            case_name: '',
            vin: '',
            car_year: '',
            car_make: '',
            car_model: '',

            brand: '',
            metric: '',
            section_width: '',
            aspect_ratio: '',
            rim_diameter: '',
            plant_code: '',
            size_code: '',
            aux_info: '',
            cure_wkyr: '',
            dot: '',

            speed_rating: '',
            load_range: '',
            construction: '',
            repairs: '',
            min_tread_depth: '',
            max_tread_depth: '',
            failure_mode: '',
            failure_factors: '',

            mfg_defect: false,
            design_defect: false,
            aging: false,

            defective_tire_alert: false,
            early_warning_alert: false,
            early_degradation_alert: false,
            forensic_investigation_alert: false,
            reported_tire_failure_alert: false,
            dealer_reported_tire_failure_alert: false,
            reported_early_waring_alert: false,

            userId: '',
            status: true
        }
    },
    reducers: {
        setLoading: (state, action) => {
            return {
                ...state,
                loading: action.payload
            }
        },

        resetPrivateDB: (state, action) => {
            return {
                ...state,
                create: {
                    case_name: '',
                    vin: '',
                    car_year: '',
                    car_make: '',
                    car_model: '',

                    brand: '',
                    metric: '',
                    section_width: '',
                    aspect_ratio: '',
                    rim_diameter: '',
                    plant_code: '',
                    size_code: '',
                    aux_info: '',
                    cure_wkyr: '',
                    dot: '',

                    speed_rating: '',
                    load_range: '',
                    construction: '',
                    repairs: '',
                    min_tread_depth: '',
                    max_tread_depth: '',
                    failure_mode: '',
                    failure_factors: '',
                    mfg_defect: false,
                    design_defect: false,
                    aging: false,

                    defective_tire_alert: false,
                    early_warning_alert: false,
                    forensic_investigation_alert: false,
                    reported_tire_failure_alert: false,
                    dealer_reported_tire_failure_alert: false,
                    reported_early_warning_alert: false,

                    userId: '',
                    status: true
                }
            }
        },

        privateDBCreate: (state, action) => {
            var cc = {
                ...state.create,
                ...action.payload
            }
            return {
                ...state,
                create: cc
            }
        },
        setHide: (state, action) => {
            return {
                ...state,
                hide: action.payload
            }
        }
    }
})

export const { privateDBCreate, setLoading, resetPrivateDB, setHide } = Privatedb.actions

export default Privatedb.reducer